import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';

// Keep your existing provider path as-is
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './components/Toast';

/** Simple error boundary so we can SEE the real error instead of a blank page */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info);
    this.setState({ info });
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 24, fontFamily: 'system-ui, sans-serif' }}>
          <h1 style={{ margin: 0 }}>App crashed</h1>
          <p style={{ marginTop: 8 }}>Copy this error block and send it to me:</p>
          <pre
            style={{
              whiteSpace: 'pre-wrap',
              background: '#0b1e3a',
              color: '#fff',
              padding: 16,
              borderRadius: 8,
              overflow: 'auto',
              maxHeight: '60vh'
            }}
          >
{String(this.state.error?.stack || this.state.error || 'Unknown error')}
{"\n\n"}{this.state.info?.componentStack || ''}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <ToastProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </ToastProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);
